{
    const lcoalResult = () => {
        let result = [];
        let promise = new Promise((resolve, reject) => {
            resolve(result);
        });

        return promise;
    };

    const wwwResult = (category, filter) => {
        let filterStr = "";
        if(!!filter){
            filterStr = `&filter=${filter}`;
        }
        let promise = new Promise((resolve, reject) => {
            fetch(`/ads/indexBanners?category=${category}${filterStr}`, {
                method: 'GET',
                credentials: 'include'})
            .then((response) => response.json())
            .then((result) => {
                result.forEach((ele)=>{
                    ele.imgUrl = `https://d1jme9zqkbqig.cloudfront.net/${ele._id}.png`
                })
                resolve(result);
            })
        });

        return promise;
    };


    // 開放給頁面使用的介面
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }

    if(window.eHanlin.dataprovider === undefined || window.eHanlin.dataprovider === null){
        window.eHanlin.dataprovider = {}
    }


    window.eHanlin.dataprovider.ads = {
        data : ((category, filter) => {
            return window.location.protocol.toLowerCase() == 'file:' ? lcoalResult() : wwwResult(category, filter);
        })
    }

}